import { Pencil, Trash2 } from 'lucide-react';
import React, { useState } from 'react';
import { visiteAPI } from '../../services/api';
import { notificaErrore, messaggioDa } from '../../utils/notifiche';

const ModuloNote = ({ modulo, visitaId, onUpdate }) => {
    const [editing, setEditing] = useState(false);
    const [contenuto, setContenuto] = useState(modulo.contenuto || { testo: '', tags: [] });

    const handleSave = async () => {
        try {
            await visiteAPI.updateModulo(modulo.id, { titolo: modulo.titolo, contenuto, ordine: modulo.ordine });
            setEditing(false);
            onUpdate();
        } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a salvare la nota')); }
    };

    const handleDelete = async () => {
        if (window.confirm('Eliminare queste note?')) {
            try {
                await visiteAPI.deleteModulo(modulo.id);
                onUpdate();
            } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a eliminare la nota')); }
        }
    };

    const handleAddTag = (e) => {
        if (e.key === 'Enter' && e.target.value.trim()) {
            e.preventDefault();
            const newTag = e.target.value.trim();
            if (!contenuto.tags.includes(newTag)) {
                setContenuto({ ...contenuto, tags: [...contenuto.tags, newTag] });
            }
            e.target.value = '';
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setContenuto({ ...contenuto, tags: contenuto.tags.filter(tag => tag !== tagToRemove) });
    };

    return (
        <div className="modulo-card modulo-note">
            <div className="modulo-header">
                <h3>{modulo.titolo}</h3>
                <div className="modulo-actions">
                    {editing ? (
                        <>
                            <button onClick={handleSave} className="btn-save">Salva</button>
                            <button onClick={() => setEditing(false)} className="btn-cancel">✕</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setEditing(true)} className="btn-edit-small"><Pencil size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                            <button onClick={handleDelete} className="btn-delete-small"><Trash2 size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                        </>
                    )}
                </div>
            </div>
            <div className="modulo-content">
                {editing ? (
                    <>
                        <textarea
                            placeholder="Scrivi le tue note..."
                            value={contenuto.testo}
                            onChange={(e) => setContenuto({ ...contenuto, testo: e.target.value })}
                            rows="8"
                            className="note-editor"
                        />
                        <div className="tags-section">
                            <label>Tags (premi Invio):</label>
                            <input type="text" placeholder="importante, followup..." onKeyDown={handleAddTag} className="tag-input" />
                            <div className="tags-list">
                                {contenuto.tags.map((tag, i) => (
                                    <span key={i} className="tag">{tag}<button onClick={() => handleRemoveTag(tag)}>✕</button></span>
                                ))}
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        {contenuto.testo ? <div className="note-text">{contenuto.testo}</div> : <p className="no-data">Nessuna nota</p>}
                        {contenuto.tags?.length > 0 && (
                            <div className="tags-display">
                                {contenuto.tags.map((tag, i) => <span key={i} className="tag tag-readonly">{tag}</span>)}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ModuloNote;
